export const GPT_EVENTS = {
    slotRequested: 'slotRequested',
}